/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:8890701e-7165-43b3-916c-eb8a40f3026c",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_LlfSO1wYX",
    "aws_user_pools_web_client_id": "2939628uasmqn5lii1iski38f6",
    "oauth": {
        "domain": "streamline7c3b875f-7c3b875f-stage.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.stage.streamline-media.net/",
        "redirectSignOut": "https://app.stage.streamline-media.net/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "delic-user-content-storage-stage100851-stage",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
